<script>
import DataProvider from './DataProvider.vue';
import LocationRepository from '../../js/repository/LocationRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        locationId: {
            type: String,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        }
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: LocationRepository.find,
                params: [this.locationId],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
